module.exports = __webpack_public_path__ + "static/img/pic4.c7daa16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case5/pic4.jpg
// module id = BX0D
// module chunks = 1